export const RESUME_COURSE_STREAM = {
  JEE: "jee",
  NEET: "neet",
  UNKNOWN: "unknown",
};

const JEE_TARGET_IDS = new Set([2]);
const NEET_TARGET_IDS = new Set([3]);

const NEET_TEXT_PATTERN = /\bneet\b/i;
const JEE_TEXT_PATTERN =
  /\bjee\b|jee[\s-]?main|jee[\s-]?advanced|pyq-jee|wbjee|bitsat|main pattern|m\+a/i;

const collectResumeItemText = (item = {}) => {
  const payload = item.payload || {};
  const raw = payload.raw || {};

  return [
    item.title,
    item.subtitle,
    payload.plannerParentName,
    raw.paper_name,
    raw.description,
    raw.format,
    raw.test_name,
    raw.test_type,
    raw.mode,
  ]
    .filter(Boolean)
    .join(" ");
};

export const resolveSelectedCourseStream = ({ targetId, targetName } = {}) => {
  const id = Number(targetId);
  if (JEE_TARGET_IDS.has(id)) return RESUME_COURSE_STREAM.JEE;
  if (NEET_TARGET_IDS.has(id)) return RESUME_COURSE_STREAM.NEET;

  const label = String(targetName || "").toLowerCase();
  if (NEET_TEXT_PATTERN.test(label)) return RESUME_COURSE_STREAM.NEET;
  if (JEE_TEXT_PATTERN.test(label)) return RESUME_COURSE_STREAM.JEE;

  return RESUME_COURSE_STREAM.UNKNOWN;
};

export const resolvePlannerCourseStream = (plannerConfig = {}) => {
  const format = String(plannerConfig.format || "").toLowerCase();
  if (format === "neet") return RESUME_COURSE_STREAM.NEET;
  if (format === "main" || format === "adv") return RESUME_COURSE_STREAM.JEE;

  const label = `${plannerConfig.parentName || ""} ${plannerConfig.type || ""}`;
  if (NEET_TEXT_PATTERN.test(label)) return RESUME_COURSE_STREAM.NEET;
  if (JEE_TEXT_PATTERN.test(label)) return RESUME_COURSE_STREAM.JEE;

  return RESUME_COURSE_STREAM.UNKNOWN;
};

export const attachCourseStreamToPlannerConfig = (plannerConfig) => ({
  ...plannerConfig,
  courseStream: resolvePlannerCourseStream(plannerConfig),
});

export const resolveResumeItemCourseStream = (item) => {
  if (!item || item.type === "video") return RESUME_COURSE_STREAM.UNKNOWN;

  const payload = item.payload || {};
  const plannerStream = payload.plannerCourseStream;
  if (
    plannerStream === RESUME_COURSE_STREAM.JEE ||
    plannerStream === RESUME_COURSE_STREAM.NEET
  ) {
    return plannerStream;
  }

  const plannerFormat = String(payload.plannerFormat || "").toLowerCase();
  if (plannerFormat === "neet") return RESUME_COURSE_STREAM.NEET;
  if (plannerFormat === "main" || plannerFormat === "adv") return RESUME_COURSE_STREAM.JEE;

  const text = collectResumeItemText(item);
  if (NEET_TEXT_PATTERN.test(text)) return RESUME_COURSE_STREAM.NEET;
  if (JEE_TEXT_PATTERN.test(text)) return RESUME_COURSE_STREAM.JEE;

  return RESUME_COURSE_STREAM.UNKNOWN;
};

export const filterResumeItemsBySelectedCourse = (items = [], courseSelection = {}) => {
  if (!Array.isArray(items) || !items.length) return [];

  const selectedStream = resolveSelectedCourseStream(courseSelection);
  if (selectedStream === RESUME_COURSE_STREAM.UNKNOWN) return items;

  return items.filter((item) => {
    if (item.type === "video") return true;

    const itemStream = resolveResumeItemCourseStream(item);
    if (itemStream === RESUME_COURSE_STREAM.UNKNOWN) return false;

    return itemStream === selectedStream;
  });
};
